// "100" (₹100)  -> "10000"  (100 * 100 = 10000 paisa)
// "100.50"      -> "10050"
// "1,234.56"    -> "123456"
export function rupeeToPaisaStr(rupeeStr: string): string {
  if (!rupeeStr) return "";

  // commas / spaces hatao
  const normalized = rupeeStr.replace(/,/g, "").trim();
  const num = Number(normalized);

  if (Number.isNaN(num)) return "";

  const paisa = Math.round(num * 100); // 2 decimal → integer paisa
  return String(paisa);
}

// "10000" (paisa) -> "100.00" (₹100.00)
// "123456"        -> "1234.56"
export function paisaToRupeeStr(paisaStr: string): string {
  if (!paisaStr) return "";

  const normalized = paisaStr.replace(/,/g, "").trim();
  const paisa = Number(normalized);

  if (Number.isNaN(paisa)) return "";

  return (paisa / 100).toFixed(2); // always 2 decimal places
}

export function rupeeToPaisaNum(value: string | number): number {
  if (value === null || value === undefined) return 0;
  const normalized =
    typeof value === "string" ? value.replace(/,/g, "").trim() : String(value);
  const num = Number(normalized);
  if (Number.isNaN(num)) return 0;
  return Math.round(num * 100);
}

export function paisaToRupeeNum(value: string | number): number {
  if (value === null || value === undefined) return 0;
  const normalized =
    typeof value === "string" ? value.replace(/,/g, "").trim() : String(value);
  const paisa = Number(normalized);
  if (Number.isNaN(paisa)) return 0;
  return paisa / 100;
}
